const HeroVariantEnum = Object.freeze({
  regular: 'regular',
  home: 'home',
  investor: 'investor',
  news: 'news',
  only_breadcrumbs : 'only_breadcrumbs'
})

export default HeroVariantEnum